export function storeToken(email: string, token: string): void {
    window.sessionStorage.setItem(`inbox_${email}`, token);
}

export function getToken(email: string): string | null {
    return window.sessionStorage.getItem(`inbox_${email}`);
}
